import React from "react";
import { FaGithub, FaOrcid, FaCheck, FaExternalLinkAlt } from "react-icons/fa";

/**
 * VerifiedBadges - Display verified account badges on profile view
 * Only shows GitHub and ORCID if they are verified AND set to display publicly
 */
const VerifiedBadges = ({ verifiedAccounts }) => {
  if (!verifiedAccounts) return null;

  const badges = [];

  // Check GitHub
  if (verifiedAccounts?.github?.verified && verifiedAccounts?.github?.display_public) {
    badges.push({
      provider: "github",
      icon: FaGithub,
      color: "#333333",
      label: "GitHub",
      link: verifiedAccounts.github.username 
        ? `https://github.com/${verifiedAccounts.github.username}` 
        : null,
      identifier: verifiedAccounts.github.username ? `@${verifiedAccounts.github.username}` : null,
    });
  }

  // Check ORCID
  if (verifiedAccounts?.orcid?.verified && verifiedAccounts?.orcid?.display_public) {
    badges.push({
      provider: "orcid",
      icon: FaOrcid,
      color: "#A6CE39",
      label: "ORCID",
      link: verifiedAccounts.orcid.orcid_id 
        ? `https://orcid.org/${verifiedAccounts.orcid.orcid_id}` 
        : null,
      identifier: verifiedAccounts.orcid.orcid_id,
    });
  }

  if (badges.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-3">
      {badges.map(({ provider, icon: Icon, color, label, link, identifier }) => {
        const badgeContent = (
          <div 
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border-2 border-gray-200 shadow-sm transition-all duration-200 group-hover:border-primary group-hover:shadow-md group-hover:scale-105"
          >
            <Icon className="w-4 h-4" style={{ color }} />
            <span className="text-xs font-semibold text-gray-700">{label}</span>
            {identifier && (
              <span className="text-xs text-gray-500 font-normal">· {identifier}</span>
            )}
            <FaCheck className="w-3 h-3 text-green-500" />
            {link && (
              <FaExternalLinkAlt className="w-3 h-3 text-gray-400 group-hover:text-primary transition-colors" />
            )}
          </div>
        );

        if (link) {
          return (
            <a
              key={provider}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline group cursor-pointer"
              title={`View ${label} profile${identifier ? `: ${identifier}` : ''}`}
            >
              {badgeContent}
            </a>
          );
        }

        return (
          <div key={provider} className="group" title={`${label} Verified`}>
            {badgeContent}
          </div>
        );
      })}
    </div>
  );
};

export default VerifiedBadges;
